import { Pipe, PipeTransform } from '@angular/core';
import { stringToColor } from '../helpers/helpers';

@Pipe({
  name: 'stringColor',
  standalone: true,
})
export class StringColorPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    return stringToColor(value || '');
  }
}
